import React from "react";

interface HeaderProps {
  onLogoClick?: () => void;
  onHowItWorksClick?: () => void;
  onTutorialsClick?: () => void;
  onBlogClick?: () => void;
  onWhatsNewClick?: () => void;
}

export function Header({ onLogoClick, onHowItWorksClick, onTutorialsClick, onBlogClick, onWhatsNewClick }: HeaderProps) {
  const handleLogoClick = () => {
    if (onLogoClick) return onLogoClick();
    window.location.href = '/';
  };

  const handleHowItWorksClick = () => {
    if (onHowItWorksClick) return onHowItWorksClick();
    window.location.href = '/how-it-works';
  };

  const handleTutorialsClick = () => {
    if (onTutorialsClick) return onTutorialsClick();
    window.location.href = '/tutorials';
  };

  const handleBlogClick = () => {
    if (onBlogClick) return onBlogClick();
    window.location.href = '/blog';
  };

  const handleWhatsNewClick = () => {
    if (onWhatsNewClick) return onWhatsNewClick();
    window.location.href = '/whats-new';
  };


  return (
    <header className="w-full sticky top-0 z-20 bg-surface-base/95 backdrop-blur border-b border-border-default/60 shadow-lg shadow-black/20">
      <div className="max-w-7xl mx-auto px-0 py-2 sm:py-3 flex items-center pl-4">
        <button 
          onClick={handleLogoClick}
          className="flex items-center gap-2 sm:gap-3 hover:opacity-90 transition-opacity cursor-pointer -ml-4 sm:-ml-6 pl-4"
        >
          <img 
            src="/logo.png" 
            alt="Snip Rush Logo" 
            className="w-9 h-7 sm:w-24 sm:h-16 rounded sm:rounded-xl ring-1 ring-border-default/60"
          />
          <div className="flex flex-col leading-tight">
            <span className="font-semibold text-base sm:text-3xl text-text-primary tracking-tight">Snip Rush</span>
            <span className="hidden sm:block text-sm text-text-muted -mt-0.5">Snip. Download. Share.</span>
          </div>
        </button>
        
        <div className="flex-1"></div>
        
        <nav className="hidden sm:flex items-center gap-6 pr-6">
          <button
            onClick={handleHowItWorksClick}
            className="text-text-secondary hover:text-accent-primary font-medium transition-colors"
          >
            How It Works
          </button>
          <button
            onClick={handleTutorialsClick}
            className="text-text-secondary hover:text-accent-primary font-medium transition-colors"
          >
            Tutorials
          </button>
          <button
            onClick={handleBlogClick}
            className="text-text-secondary hover:text-accent-primary font-medium transition-colors"
          >
            Blog
          </button>
          <button
            onClick={handleWhatsNewClick}
            className="text-text-secondary hover:text-accent-primary font-medium transition-colors"
          >
            What's New
          </button>
        </nav>
      </div>
    </header>
  );
}

